import { WEBCOIN_SECTIONS } from '@wwe-portal/web/utils/constants/webcoin';
import { useTranslations } from 'next-intl';
import RefreshTimer from '../refresh-timer/refresh-timer';
import { Frame } from '@wwe-portal/entities/webcoin.type';
import ShopOfferCardMobileWrapper from '../../offer-card/offer-card-mobile-wrapper';

export const DailyWebCoinListMobile = ({
  ref,
  pacificDate,
  handleUpdateLiveList,
  handlePurchaseDailyWebCoinOffer,
  purchasingOffer,
  webCoinDailyOffers,
}: {
  ref: React.RefObject<HTMLDivElement | null>;
  pacificDate: string;
  handleUpdateLiveList: () => void;
  handlePurchaseDailyWebCoinOffer: ({ offerId, price, title }) => void;
  purchasingOffer: any;
  webCoinDailyOffers: Frame[];
}) => {
  const t = useTranslations();

  return (
    <div className="mb-[25px]" id={WEBCOIN_SECTIONS.DAILY_WEBCOIN_OFFERS}>
      <div
        ref={ref}
        className="shop-featured mb-[10px] flex justify-between pt-0"
      >
        <h4 className="mb-0 text-base font-semibold">
          {t('daily_web_coin_offers')}
        </h4>
        {pacificDate && (
          <RefreshTimer
            time={pacificDate}
            handleTimerFromChild={handleUpdateLiveList}
          />
        )}
      </div>
      <p className={`text-text600 mb-8 text-xs`}>
        {t('daily_web_coin_offers_description')}
      </p>
      <ShopOfferCardMobileWrapper
        hasWebCoinPrice={true}
        transactionStarted={purchasingOffer?.offerId}
        handlePurchase={handlePurchaseDailyWebCoinOffer}
        offers={webCoinDailyOffers ?? []}
        offerType="daily"
        buttonText={t('daily_offers')}
      />
    </div>
  );
};
